import { CRUISE_BUNDLE_HOTEL_ITEM_TYPES } from 'constants/cruise'

const normalizeCabinType = (cabinType?: string | null): string => {
  return cabinType?.trim().toLowerCase() ?? ''
}

const getBundleFlightCredits = (bundle?: App.CruiseOfferBundle): Array<App.CruiseOfferBundleFlightCredit> => {
  return bundle?.flightCredits ?? []
}

export function getCruiseBundleHotelItemNames(bundle: App.CruiseOfferBundle): Array<string> {
  return bundle.items
    .filter((item) => CRUISE_BUNDLE_HOTEL_ITEM_TYPES.has(item.itemType))
    .map((item) => item.displayName.trim())
    .filter(Boolean)
}

export const getMaxBundleFlightCredit = (bundle?: App.CruiseOfferBundle): number => {
  return getBundleFlightCredits(bundle).reduce((maxCredit, flightCredit) => {
    return Math.max(maxCredit, flightCredit.flightCreditAmount ?? 0)
  }, 0)
}

export const getMinBundleFlightCredit = (bundle?: App.CruiseOfferBundle): number => {
  const minFlightCredit = getBundleFlightCredits(bundle).reduce((minCredit, flightCredit) => {
    const amount = Math.max(flightCredit.flightCreditAmount ?? 0, 0)
    if (amount <= 0) {
      return minCredit
    }

    return Math.min(minCredit, amount)
  }, Infinity)

  return Number.isFinite(minFlightCredit) ? minFlightCredit : 0
}

export const hasAnyBundleFlightCredits = (bundle?: App.CruiseOfferBundle): boolean => {
  return getMaxBundleFlightCredit(bundle) > 0
}

export const hasBundleInclusions = (bundle?: App.CruiseOfferBundle): boolean => {
  if (!bundle?.rateCodes.length) {
    return false
  }

  return (
    getCruiseBundleHotelItemNames(bundle).length > 0 ||
    hasAnyBundleFlightCredits(bundle)
  )
}

export const getBundleFlightCreditForCabinType = (
  bundle: App.CruiseOfferBundle | undefined,
  cabinType: string | undefined,
): number => {
  const normalizedCabinType = normalizeCabinType(cabinType)
  if (!normalizedCabinType) {
    return getMaxBundleFlightCredit(bundle)
  }

  const flightCredit = getBundleFlightCredits(bundle).find((bundleFlightCredit) => (
    normalizeCabinType(bundleFlightCredit.cabinType) === normalizedCabinType
  ))

  return Math.max(flightCredit?.flightCreditAmount ?? 0, 0)
}
